<div class="operations">

  @for (action of actions; track action.id) {
    <app-menu-group-button [matTooltip]="action.$$toolTip" [matTooltipDisabled]="false" [disabled]="disabled" [readonly]="action.$$disabled || !action.read_access && readonly" (itemClick)="onActionClick($event)" [item]="action"></app-menu-group-button>
  }

</div>
